export const IMAGE_DATABASE = [
  {
    id: 1,
    name: 'Urban',
    url: 'img/urban.jpg',
    thumbnail: 'img/thumbnails/urban.jpg',
    description:
      'A cluster of Water tanks & Dish antennas on the terrace of multi-story apartment building',
    dateTaken: 'May 2022',
    location: 'Chandigarh',
    exif: {
      camera: 'Sony Alpha 6000',
      aperture: 'f/6.3',
      shutterSpeed: '1/320s',
      focalLength: '250mm',
      ISO: '640',
    },
    tags: ['URBAN'],
  },
  {
    id: 2,
    name: 'Spices',
    url: 'img/spices.jpg',
    thumbnail: 'img/thumbnails/spices.jpg',
    description:
      'Whole Spices used in indian kitchens. This photo contains cumin, cardamom, cloves & cinnamon.',
    dateTaken: 'March 2022',
    location: 'Panchkula',
    exif: {
      camera: 'Moto Edge 20',
      aperture: 'f/1.9',
      shutterSpeed: '1/20s',
      focalLength: '24mm',
      ISO: '160',
    },
    tags: ['MACRO', 'FOOD'],
  },
  {
    id: 3,
    name: 'Silhouette',
    url: 'img/silhouette.jpg',
    thumbnail: 'img/thumbnails/silhouette.jpg',
    description: 'Silhouettes or shadow-ouline photography yields minimal looking photo.',
    dateTaken: 'March 2022',
    location: 'Chandigarh',
    exif: {
      camera: 'Moto Edge 20',
      aperture: 'f/1.9',
      shutterSpeed: '1/30s',
      focalLength: '24mm',
      ISO: '3200',
    },
    tags: ['URBAN', 'SILHOUETTE', 'LOW LIGHT'],
  },
  {
    id: 4,
    name: 'Road',
    url: 'img/road.jpg',
    thumbnail: 'img/thumbnails/road.jpg',
    description:
      'High speed of moving vehicle is complemented by slower shutter speed to capture the motion',
    dateTaken: 'March 2022',
    location: 'Kaithal',
    exif: {
      camera: 'Moto Edge 20',
      aperture: 'f/1.9',
      shutterSpeed: '1/30s',
      focalLength: '24mm',
      ISO: '100',
    },
    tags: ['SLOW SHUTTER', 'ONE-POINT PERSPECTIVE'],
  },
  {
    id: 5,
    name: 'Nature',
    url: 'img/nature.jpg',
    thumbnail: 'img/thumbnails/nature.jpg',
    description:
      'Indian monsoon season brings lot of changes in nature, like this tree bearing Unripe Mango Triplets. ',
    dateTaken: 'May 2022',
    location: 'Panchkula',
    exif: {
      camera: 'Sony Alpha 6000',
      aperture: 'f/6.3',
      shutterSpeed: '1/250s',
      focalLength: '315mm',
      ISO: '800',
    },
    tags: ['NATURE'],
  },
  {
    id: 6,
    name: 'Macro',
    url: 'img/macro.jpg',
    thumbnail: 'img/thumbnails/macro.jpg',
    description:
      'Small creatures are hidden all summer long, but they can be spotted after a rainfall',
    dateTaken: 'May 2022',
    location: 'Chandigarh',
    exif: {
      camera: 'Sony Alpha 6000',
      aperture: 'f/8',
      shutterSpeed: '1/2500s',
      focalLength: '315mm',
      ISO: '2000',
    },
    tags: ['MACRO', 'NATURE'],
  },
  {
    id: 7,
    name: 'Food',
    url: 'img/food.jpg',
    thumbnail: 'img/thumbnails/food.jpg',
    description: 'One pot recipes are easy to cook, fulfilling to eat & easy to clean later!',
    dateTaken: 'April 2020',
    location: 'Pune',
    exif: {
      camera: 'Moto X4',
      aperture: 'f/2.0',
      shutterSpeed: '1/100s',
      focalLength: '24mm',
      ISO: '125',
    },
    tags: ['FOOD', 'MACRO'],
  },
  {
    id: 8,
    name: 'Fire',
    url: 'img/fire.jpg',
    thumbnail: 'img/thumbnails/fire.jpg',
    description:
      "A photo of Flames, shot on 'Lohri', a festival celebrated in the month of January in North India.",
    dateTaken: 'Jan 2022',
    location: 'Panchkula',
    exif: {
      camera: 'Moto Edge 20',
      aperture: 'f/1.9',
      shutterSpeed: '1/500s',
      focalLength: '24mm',
      ISO: '400',
    },
    tags: ['FIRE', 'HIGH SPEED', 'LOW LIGHT'],
  },
];
